import { clearAllOIDCInfo } from '../lib/oidc/clearAllOIDCInfo';
import {
  LAST_VALID_INSTANCE_NAME_STORAGE_KEY,
  loadRootInstanceName,
  ROOT_INSTANCE_NAME_STORAGE_KEY,
  storeInstanceName,
} from '../lib/oidc/oidcAuthInfo';
import {
  UNITY_GO_BACK_URL_KEY,
  USER_SESSION_LOCALSTORAGE_KEY,
  USER_SSO_CONFIG_KEY,
  WORK_AS_ENDED_KEY,
  WORK_AS_USER_SESSION_LOCALSTORAGE_KEY,
} from './constants';

export function cleanLocalStorage(): void {
  // impersonation overwrites instance_name with the impersonated one - restore the original so that an abandoned
  // impersonation (closed tab, expired session) doesn't leak the impersonated instance into the next login
  const rootInstanceName = loadRootInstanceName();

  if (rootInstanceName) {
    storeInstanceName(rootInstanceName);
  }

  localStorage.removeItem(USER_SESSION_LOCALSTORAGE_KEY);
  localStorage.removeItem(WORK_AS_USER_SESSION_LOCALSTORAGE_KEY);
  localStorage.removeItem(UNITY_GO_BACK_URL_KEY);
  localStorage.removeItem(WORK_AS_ENDED_KEY);
  localStorage.removeItem(USER_SSO_CONFIG_KEY);

  localStorage.removeItem(LAST_VALID_INSTANCE_NAME_STORAGE_KEY);
  localStorage.removeItem(ROOT_INSTANCE_NAME_STORAGE_KEY);

  clearAllOIDCInfo();
}
